/**
 * Map DB tender row (snake_case) to UI shape (camelCase) for list, form, and details.
 */
export function mapRowToTender(row) {
  if (!row) return null;
  const d = (v) => (v == null ? undefined : v);
  const dateStr = (v) => (v ? (typeof v === 'string' ? v.slice(0, 10) : v) : undefined);
  return {
    id: row.id,
    tenderId: row.tender_id,
    referenceNumber: row.tender_id,
    title: row.title,
    client: d(row.issuing_authority),
    department: d(row.department),
    projectLocation: d(row.project_location),
    issuingAuthority: d(row.issuing_authority),
    description: d(row.description),
    notes: d(row.notes),
    issueDate: dateStr(row.issue_date),
    clarificationDeadline: dateStr(row.clarification_deadline),
    submissionDeadline: dateStr(row.submission_deadline),
    openingDate: dateStr(row.opening_date),
    expectedAwardDate: dateStr(row.expected_award_date),
    tenderValidityDays: row.tender_validity_days != null ? String(row.tender_validity_days) : '',
    proposalSubmissionDeadline: dateStr(row.proposal_submission_deadline),
    assignmentReminderEmail: row.assignment_reminder_email_enabled === true,
    assignmentReminderDaysBefore:
      row.assignment_reminder_days_before != null ? String(row.assignment_reminder_days_before) : '',
    assignmentReminderCustomDate: dateStr(row.assignment_reminder_custom_date),
    estimatedValue: row.estimated_value != null ? String(row.estimated_value) : '',
    currency: d(row.currency) || 'OMR',
    bidFee: row.bid_fee != null ? String(row.bid_fee) : '',
    tenderBondRequired: Boolean(row.tender_bond_required),
    bondAmount: row.bond_amount != null ? String(row.bond_amount) : '',
    projectDuration: d(row.project_duration),
    assignedEmployee: d(row.assigned_employee),
    assignedTo: d(row.assigned_employee),
    assignedToUserId: d(row.assigned_to_user_id),
    internalReviewStatus: d(row.internal_review_status) || 'Pending',
    approvalRequired: row.approval_required !== false,
    approvalNotes: d(row.approval_notes),
    status: d(row.status) || 'Draft',
    approved: d(row.approved) || 'Not approved',
    requestedBy: d(row.requested_by),
    submittedDate: dateStr(row.submitted_date),
    approvedBy: d(row.approved_by),
    approvedDate: dateStr(row.approved_date),
    lastFollowUp: dateStr(row.last_follow_up),
    created: dateStr(row.created_at),
  };
}
